export default "__VITE_ASSET__D_Cw7EaC__"